import React, { useRef } from 'react';
import './AppScreenshots.css';

const screens = [
  { src: '/assets/images2/sign_up_screen.png',         label: 'Create Account' },
  { src: '/assets/images2/login_screen.png',           label: 'Welcome Back' },
  { src: '/assets/images2/onboarding_screen_1.png',    label: 'Basic Info' },
  { src: '/assets/images2/onboarding_screen_2.png',    label: 'Your Goal' },
  { src: '/assets/images2/onboarding_screen_3.png',    label: 'Training Environment' },
  { src: '/assets/images2/onboarding_screen_3_v2.png', label: 'Choose Your Setup' },
  { src: '/assets/images2/onboarding_screen_4.png',    label: 'Experience Level' },
  { src: '/assets/images2/onboarding_screen_5.png',    label: 'Injuries & Limitations' },
  { src: '/assets/images2/onboarding_screen_6.png',    label: 'Food Restrictions' },
  { src: '/assets/images2/onboarding_screen_7.png',    label: 'Body Measurements' },
  { src: '/assets/images2/onboarding_screen_8.png',    label: 'Strength PRs' },
  { src: '/assets/images2/onboarding_screen_9.png',    label: 'Starting Photos' },
  { src: '/assets/images2/onboarding_screen_10.png',   label: 'Note for AI' },
  { src: '/assets/images2/onboarding_screen_11.png',   label: 'Plan Summary' },
  { src: '/assets/images2/home_screen.png',            label: 'Home Dashboard' },
  { src: '/assets/images2/train_screen.png',           label: 'Training Plan' },
  { src: '/assets/images2/single_exercise_screen.png',     label: 'Workout Details' },
  { src: '/assets/images2/alternative_exercise.png',        label: 'Alternative Exercises' },
  { src: '/assets/images2/train_session_screen.png', label: 'AI Session Feedback' },
  { src: '/assets/images2/workout_complete_screen.png', label: 'Post-Session Analysis' },
  { src: '/assets/images2/nutrition_screen.png',       label: 'Nutrition Tracking' },
  { src: '/assets/images2/nutrition_screen_v2.png',       label: 'Nutrition Plan' },
  { src: '/assets/images2/ai_message_screen.png',               label: 'AI Coach' },
  { src: '/assets/images2/progress_screen.png',             label: 'Progress Overview' },
  { src: '/assets/images2/exercise_history_screen.png',   label: 'Exercise History' },
  { src: '/assets/images2/exercises_history.png',      label: 'All Exercises Log' },
  { src: '/assets/images2/profile_screen.png',         label: 'Profile & Stats' },
  { src: '/assets/images2/this_week_screen.png',           label: 'This Week' },
];

const AppScreenshots: React.FC = () => {
  const trackRef = useRef<HTMLDivElement>(null);

  const scroll = (dir: 'left' | 'right') => {
    if (!trackRef.current) return;
    trackRef.current.scrollBy({ left: dir === 'left' ? -280 : 280, behavior: 'smooth' });
  };

  return (
    <section className="screenshots" id="screenshots">
      <div className="container">
        <div className="screenshots__header">
          <div>
            <span className="section-label">App Screenshots</span>
            <h2 className="section-title">
              See every screen,<br /><span>know what to expect</span>
            </h2>
          </div>
          <div className="screenshots__arrows">
            <button className="screenshots__arrow" onClick={() => scroll('left')} aria-label="Scroll left">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M15 18l-6-6 6-6"/>
              </svg>
            </button>
            <button className="screenshots__arrow" onClick={() => scroll('right')} aria-label="Scroll right">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M9 18l6-6-6-6"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div className="screenshots__track-wrap">
        <div className="screenshots__fade screenshots__fade--left" />
        <div className="screenshots__track" ref={trackRef}>
          {screens.map((s, i) => (
            <div className="screenshots__item" key={i}>
              <div className="screenshots__phone">
                <div className="screenshots__phone-notch" />
                <img src={s.src} alt={s.label} className="screenshots__img" loading="lazy" />
              </div>
              <p className="screenshots__label">{s.label}</p>
            </div>
          ))}
        </div>
        <div className="screenshots__fade screenshots__fade--right" />
      </div>
    </section>
  );
};

export default AppScreenshots;
